import graphql__fe8ddc0df3fd410e20dc from "./__generated__/ContributionsMapContributions_participativeModule.graphql.js";import { Suspense } from "react";
import { graphql, useFragment } from "react-relay";

import { BoxSpinner } from "../../../Utils/Spinner";
import ContributionsListFilters from "../ContributionsListFilters";
import ContributionsMapContributionsList from "./ContributionsMapContributionsList";
import { ContributionsMapContributionsFragment_participativeModule } from "./ContributionsMapContributionsFragment";

const ContributionsMapContributions = props => {
  const participativeModule = useFragment(
    ContributionsMapContributions_participativeModule,
    props.participativeModule
  );

  return (
    <>
      <ContributionsListFilters
        participativeModule={participativeModule}
        refetchFragment={ContributionsMapContributionsFragment_participativeModule}
        // Themes filter is rendered with a dedicated view for the map
        disableThemesFilter={true}
      />

      <Suspense fallback={<BoxSpinner />}>
        <ContributionsMapContributionsList participativeModule={participativeModule} />
      </Suspense>
    </>
  );
};

const ContributionsMapContributions_participativeModule = graphql__fe8ddc0df3fd410e20dc;

export default ContributionsMapContributions;
